import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotateRight } from "@fortawesome/free-solid-svg-icons";
import "./listLoadError.scss";

/**
 * What a list shows when its load FAILED.
 *
 * A list page showed its empty text, such as «لا يوجد سائقين», when the request
 * failed. An operator then read "there are none" for "the server did not
 * answer". This block says that the load failed, shows the API's own sentence
 * (with the reference of a server error, see api/requestReference.js), and
 * gives one action: load again.
 *
 * Put it after the `<table>`, inside `.table-container`. Show it only when the
 * list has no rows: rows from the last good load are better than a notice.
 *
 * @param {object} props
 * @param {string} [props.title]
 * @param {string|null} [props.message] - the reason, as the API gave it
 * @param {() => void} [props.onRetry]
 * @param {boolean} [props.isRetrying] - the load runs again now
 */
const ListLoadError = ({
    title = "تعذر تحميل القائمة",
    message = null,
    onRetry,
    isRetrying = false,
}) => (
    <div className="list-load-error surface-card" role="alert">
        <p className="list-load-error__title">{title}</p>
        {message ? (
            <p className="list-load-error__message">
                <bdi>{message}</bdi>
            </p>
        ) : null}
        {onRetry ? (
            <button
                type="button"
                className="btn btn-outline-secondary btn-sm"
                onClick={() => onRetry()}
                disabled={isRetrying}
            >
                <FontAwesomeIcon icon={faRotateRight} spin={isRetrying} /> إعادة المحاولة
            </button>
        ) : null}
    </div>
);

export default ListLoadError;
